var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "16px / phone_light"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 4C16 1.79086 14.2091 0 12 0H4C1.79086 0 0 1.79086 0 4V12C0 14.2091 1.79086 16 4 16H12C14.2091 16 16 14.2091 16 12V4ZM9.99111 9.25333C10.4844 9.41333 11.0133 9.50222 11.56 9.50222C11.8 9.50222 12 9.70222 12 9.94222V11.4756C12 11.72 11.8756 12 11.56 12C7.43556 12 4 8.56889 4 4.44C4 4.10667 4.28889 4 4.52889 4H6.06667C6.30667 4 6.50667 4.2 6.50667 4.44C6.50667 4.98667 6.59111 5.51556 6.75556 6.00889C6.80444 6.16444 6.76889 6.33778 6.64889 6.46222C6.13824 6.89692 5.97306 7.63242 6.37189 8.17155C6.79448 8.74278 7.3159 9.25338 7.88408 9.66306C8.41578 10.0464 9.13369 9.87262 9.54222 9.36C9.66222 9.24 9.83556 9.2 9.99111 9.25333Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneLight);
export default __webpack_public_path__ + "static/media/phone_light.5f5aff582540473bec76d4d22f34e13b.svg";
export { ForwardRef as ReactComponent };